import React from "react";
import classes from "./CenterSidebar.module.css";
import LinkButton from "../UI/LinkButton/LinkButton";

interface Props {
    path: string;
}

const CenterSidebar = ({ path }: Props) => {
    return (
        <div className={classes.centerSidebar__buttons}>
            <LinkButton to={"centers"}>Назад</LinkButton>
            <LinkButton to={`${path}/data`}>Общая информация</LinkButton>
            <LinkButton to={`${path}/contacts`}>Контакты</LinkButton>
            <LinkButton to={`${path}/prototypes`}>Прототипы</LinkButton>
            <LinkButton to={`${path}/services`}>Дополнительные услуги</LinkButton>
            <LinkButton to={`${path}/residents`}>Резиденты</LinkButton>
            <LinkButton to={`${path}/schedule`}>Штатное расписание</LinkButton>
            <LinkButton to={`${path}/equipment`}>Оборудование</LinkButton>
            {/* <LinkButton to={`${path}/accounting`}>Сметы</LinkButton> */}
            <LinkButton to={`${path}/events`}>Мероприятия</LinkButton>
            <LinkButton to={`${path}/reports`}>Карточки и список продуктов</LinkButton>
            <LinkButton to={`${path}/documents`}>Документы</LinkButton>
            <LinkButton to={`${path}/reportSchedule`}>Отчеты</LinkButton>
            <LinkButton to={`${path}/reportControlPoints`}>Контрольные точки</LinkButton>
            {/* <LinkButton to={`${path}/orders`}>Заявки</LinkButton> */}
        </div>
    );
};

export default CenterSidebar;
